import { Component, OnInit } from '@angular/core';

class model {
	news = [
		{ Title: "Fireless Cooking Competition", newsId: 'firelessCooking' },
		{ Title: "Kannada Rajyotsava", newsId: 'rajyotsava' },
		{ Title: "Children's Day / Ethnic Day", newsId: 'ethnicDay' },
		{ Title: "Robotics Workshop", newsId: 'roboWorkshop' },
		{ Title: "Kargil Vijay Diwas Day", newsId: 'kargilVijayDiwasDay' },
		// { Title:"Invitation for Rasa Sanje Programme 2016", newsId:'rasasanje2016'}
	];
}

@Component({
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/home/home.component.ts